import * as React from "react"
import { useSignal } from "@preact/signals-react"
import { Box, Stack, Typography } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"

import { PlaceholderVideoImg } from "@components"


export default function ModalVideosContainer({ videos = [], initPos=0 }) {
	const selected = useSignal(initPos)
	const render = useSignal(true)

	let videoUrlFormatted = videos[selected.value]
	const isYoutubeVideo = !!videoUrlFormatted && (videoUrlFormatted.includes('.youtube.') || videoUrlFormatted.includes('youtu.be'))
	const isVimeoVideo = !!videoUrlFormatted && videoUrlFormatted.includes('vimeo')

	if (isYoutubeVideo && (videoUrlFormatted.includes('//youtu.be/') || videoUrlFormatted.includes('oembed?url='))) {
		let youtubeID = videoUrlFormatted.split("youtu.be/")[ 1 ]
		if (!youtubeID)
			youtubeID = videoUrlFormatted.split("watch%3Fv%3D")[ 1 ]
		if (youtubeID.includes('&'))
			youtubeID = youtubeID.split('&')[ 0 ]
		videoUrlFormatted = `https://www.youtube.com/watch?v=${youtubeID}`
	} else if (isYoutubeVideo && videoUrlFormatted.includes('/v/')) {
		let youtubeID = videoUrlFormatted.split("/v/")[ 1 ]
		if (youtubeID.includes('?'))
			youtubeID = youtubeID.split('?')[ 0 ]
		videoUrlFormatted = `https://www.youtube.com/watch?v=${youtubeID}`
	}

	return <Stack sx={{ alignItems: "center", rowGap:"1rem" }}>
		{!isYoutubeVideo && !isVimeoVideo && <Box>
			<Typography>
				<IconSeeker icon="info-circle" iconWeight="regular" /> This is not a Youtube video, it may not be played
			</Typography>
			{ !!render.value && <video style={{ maxWidth: '600px', maxHeight: '600px', paddingTop: '20px' }} controls>
				<source src={videoUrlFormatted} type="video/mp4" />
			</video> }
		</Box>}

		{isVimeoVideo && <Box>
			<Box style={{ maxWidth: '600px', maxHeight: '600px', margin: 'auto', paddingBottom: '20px' }}>
				<Typography>This is a Vimeo video that can not be played</Typography>
			</Box>
		</Box> }

		{ isYoutubeVideo &&  <iframe width="600px" height="600px" src={videoUrlFormatted.replace('/watch?v=', '/embed/')} title="Youtube Video" allowFullScreen /> }

		<Stack direction="row" gap={2}>
			{ videos.map((vid, idx) => <PlaceholderVideoImg
				key={idx}
				onClick={() => {
					render.value = false
					setTimeout(() => {
						selected.value = idx
						render.value = true
					}, 100)
				}}
				sx={{ ...selected.value === idx && { border: "3px solid", borderColor: "info.main" } }}
			/>) }
		</Stack>
	</Stack>
}